/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import React from "react";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";

export default function Footer({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { releaseDate, representative, creator } = formField;

  return (
    <Box mt={5}>
      <Grid container spacing={3}>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            label={creator.label}
            name={creator.name}
            value={values.creator}
            error={errors.creator && touched.creator}
            success={values.creator?.toString().length > 0 && !errors.creator}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={representative.label}
            name={representative.name}
            value={values.representative}
            error={errors.representative && touched.representative}
            success={values.representative?.toString().length > 0 && !errors.representative}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={releaseDate.label}
            name={releaseDate.name}
            error={errors.releaseDate && touched.releaseDate}
            success={values.releaseDate?.toString().length > 0 && !errors.releaseDate}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
